import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-page-error',
  templateUrl: './page-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./page-error.component.scss'],
})
export class PageErrorComponent {
  @HostBinding('class') hostClass = 'd-flex w-100';
}
